import { useState, useEffect, useCallback } from 'react';
import { subscribeToPush, unsubscribeFromPush, getPushStatus } from '@/utils/pushNotifications';

export function usePushSubscription(employeeId) {
  const [status, setStatus] = useState('loading'); // loading | unsupported | denied | prompt | subscribed

  const checkStatus = useCallback(async () => {
    const s = await getPushStatus();
    setStatus(s);
  }, []);

  useEffect(() => {
    checkStatus();
  }, [checkStatus]);

  const subscribe = useCallback(async () => {
    if (!employeeId) return;
    try {
      const result = await subscribeToPush(employeeId);
      if (result.subscribed) {
        setStatus('subscribed');
      } else if (result.permitted === false) {
        setStatus('denied');
      }
    } catch {
      // silent fail
    }
  }, [employeeId]);

  const unsubscribe = useCallback(async () => {
    if (!employeeId) return;
    try {
      await unsubscribeFromPush(employeeId);
      setStatus('prompt');
    } catch {
      // silent fail
    }
  }, [employeeId]);

  return { status, subscribe, unsubscribe };
}
